<template>
    <el-input
      v-if="showValueType"
      class="verticallyCenter"
      type="number"
      v-model="value1"
      :max="max"
      :min="min"
      :step="step"
      @blur="blurEvent('originValue','value1')"
      @focus="getFocus($event)"
      @input="inputEvent"
      @change = "changeEvent"
      :disabled = "disabled"
      :placeholder="placeHolderText"
      @keyup.native="keyupEvent($event)"
      @wheel.native.prevent
    >
      <!--    有单位类型选择的情况-->
      <template slot="suffix">
        <el-dropdown trigger="click" @command="valueTypeHandleCommand">
          <span class="el-dropdown-link lineHeight32" :class="widthIcon"
                v-if="originValueType === 'normal'"></span>
          <span class="el-dropdown-link lineHeight32" v-else>
                      {{ originValueType }}
         </span>
          <el-dropdown-menu slot="dropdown" class="dropdown-size" :class="dropdownClass">
            <el-dropdown-item v-for="(sizeType, index) in sizeTypes" :key="index" :command="sizeType.value"
            >
            <span
              class="selected-icon"
              :class="originValueType === sizeType.value ? 'icon-portal-check-small' : ''"
            ></span>
              {{ sizeType.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-input>
    <el-input
      v-else
      v-inputHandle="{ this1, type: 'originValue',max: max, min: min,noInputHandle:noInputHandle, step:step,reduceStep:reduceStep}"
      type="number"
      v-model="value1"
      :max="max"
      :min="min"
      :step="step"
      @blur="blurEvent('originValue','value1')"
      @focus="getFocus($event)"
      @input="inputEvent"
      @change = "changeEvent"
      @keyup.native="keyupEvent($event)"
      :disabled = "disabled"
      :placeholder="placeHolderText"
      @wheel.native.prevent
    >
      <!--  单纯单位的情况  -->
      <template slot="suffix" v-if="!noInputSuffixs">
        <span class="suffix_text">{{inputSuffixs}}</span>
      </template>
    </el-input>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
import { historyCombineWrap } from "utils/revork"
export default {
  mixins: [publicData],
  name: "singleInput",
  props: {
    dropdownClass: String,
    title: {
      type: String,
      default: ""
    },
    value: {
      required: true
    },
    noInputSuffixs:{
      type: Boolean,
      default: false
    },
    noInputHandle:{
      type: Boolean,
      default: false
    },
    placeHolderText: {
      type: String,
      default: "请输入"
    },
    inputSuffixs: {
      type: [String]
    },
    max:{
      type: [Number],
    },
    min:{
      type: [Number],
      default: 0
    },
    step:{
      type: [Number],
    },
    disabled:{
       type: Boolean
    },
    showValueType:{
      type: Boolean,
      default: false
    },
    showAuto:{
      type: Boolean,
      default: false
    },
    valueType:{
      type: String
    },
    defaultPxValue: {
      type: Number,
      default: 200
    },
    defaultPercentValue: {
      type: Number,
      default: 100
    },
    reduceStep:{
      type: Number
    }
  },
  watch:{
    ids: {
      handler: function (newVal, oldVal) {
        this.initData()
      },
      immediate: true,
      deep: true
    },
    originValue(newVal, oldVal){
      if (newVal !== oldVal) {
        this.value1 = newVal
      }
    },
    value1(newVal,oldval){
      if(this.isFocus){
        sessionStorage.setItem('tempSize',true)
      }
    },
    showAuto:{
      handler: function (newVal, oldVal) {
        if(newVal){
          this.sizeTypes = [
            {
              label: "自动",
              value: "normal",
              icon: "el-icon-arrow-down"
            },
            {
              label: "px",
              value: "px"
            },
            {
              label: "%",
              value: "%"
            }
          ]
        }else {
          this.sizeTypes = [
            {
              label: "px",
              value: "px"
            },
            {
              label: "%",
              value: "%"
            }
          ]
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      isFocus: false,
      value1:0,
      inputWidth: {},
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ]
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ids(){
      return this.$store.state.states.activeID
    },
    originValue: {
      get() {
        return !isNaN(this.value) ? Number(this.value) : undefined
      },
      set(val) {
        let newVal = Number(val)
        if (this.request_prefix !== 'bigScreen') {
          newVal = val>this.max?this.max:val
          newVal = newVal < this.min ? this.min:newVal
        }
        this.$emit("update:value", newVal)
      }
    },
    widthIcon() {
      return this.sizeTypes?.find(item => item.value === this.originValueType)?.icon
    },
    originValueType: {
      get() {
        return this.valueType
      },
      set(val) {
        this.$emit("update:valueType", val)
      }
    }
  },
  methods: {
    keyDownEvent(e){
      let key = window.event.keyCode
      //enter键  待完善
      if ((key === 38 || key === 40) && this.isFocus) {
        e.target.select()
        setTimeout(()=>{
          this.setValue('originValue','value1')
          this.$emit("customBlur")
        },50)
      }
    },
    inputEvent(){
      this.$emit("input")
    },
    changeEvent(){
      this.$emit("change")
    },
    getFocus(event) {
      this.isFocus = true
      event.currentTarget.select()
    },
    initData(){
      this.value1 = this.originValue
    },
    keyupEvent(e){
      this.$emit("keyup",e)
      this.keyDownEvent(e)
    },
    blurEvent(){
      this.isFocus = false
      sessionStorage.removeItem('tempSize')
      this.setValue('originValue','value1')
      this.$emit("customBlur")
    },
    setValue(originName,name){
      if(this[name]){
        let val =  Number(this[name])
        if(Number(this.max) && val > this.max){
          this[name] = this.max
        }
        if(Number(this.min) && val < this.min){
          this[name] = this.min
        }
        this[originName] = val
      }else{
        // 不允许输入为空 为空的情况恢复原来的值
        this[name] = Number(this[originName])
      }
      this.$nextTick(()=>{
        this.$emit("changeValue")
      })
    },
    valueTypeHandleCommand: historyCombineWrap(function (val){
      if (this.originValueType === val) {
        return
      }
      if(val === 'auto'){
        this.originValue = ''
      }
      this.originValueType = val
      switch(val){
        case "%":
          this.originValue = this.defaultPercentValue
          break
        case "px":
          this.originValue = this.defaultPxValue
          break
        case "auto":
          this.originValue = ''
          break
        default:
          this.originValue = this.defaultPxValue
      }
    })
  }
}
</script>

<style scoped>
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.icon-portal-check-small {
  margin-right: 8px;
  color: rgba(43, 103, 255, 1);
  vertical-align: middle;
}
</style>
